import { ContentSwitcherByState } from 'components/Atoms/ContentSwitcherByState'
import { AvatarForm } from 'components/Molecules/AvatarForm'
import { useUser } from 'hooks/user/useUser'
import { useEffect, useState } from 'react'
import { OrderUpdateModalCss, SignOutLink } from './ProfileModalCSS.styled'
import { useUsernameUpdate } from 'hooks/user/useUsernameUpdate'
import { useSignInUpOut } from 'hooks/user/useSignInUpOut'
import { useWalletConnection } from 'hooks/useWalletConnection'
import { isEmpty } from 'lodash'

// tabs
import { UserOverview } from './Tabs/UserOverview'
import { UserPreferences } from './Tabs/UserPreferences'
import { UserMyReferrals } from './Tabs/UserMyReferrals'
// import { UserApiKeys } from './Tabs/UserApiKeys'
import { BidCloning } from './Tabs/BidCloning'

/* prettier-ignore */
const TABS = [
  { id: 'user-overview_tab_one', caption: 'OVERVIEW', gridWidth: '1fr', panel: <UserOverview /> },
  { id: 'user-prefs_tab_two', caption: 'PREFERENCES', gridWidth: '1fr', panel: <UserPreferences /> },
  { id: 'user-api_tab_three',    caption: 'MY REFERRALS',    gridWidth:'1fr', panel: <UserMyReferrals/> },
  { id: 'user-api_tab_four', caption: 'BID CLONING', gridWidth: '1fr', panel: <BidCloning /> },
]

const gridColumns = TABS.reduce((array, item) => [...array, item.gridWidth], []).join(' ')

export const UserProfileModal = ({ closeModal, otherUserAddress, selectedTabId }) => {
  const { signOut } = useSignInUpOut()
  const { disconnectWallet } = useWalletConnection()

  const { username, email } = useUser('profile')

  const { updateUsername } = useUsernameUpdate()

  const [state, setState] = useState(otherUserAddress ? 'public' : 'read')
  const [newUsername, setNewUsername] = useState('')
  const [newTwitterId, setNewTwitterId] = useState('')

  const [activeTabId, setActiveTabId] = useState()

  const saveClick = () => {
    !!newUsername && updateUsername(newUsername)
    setState('read')
  }

  useEffect(() => {
    if (selectedTabId) {
      const selectedTab = TABS.find((tab) => tab.id === selectedTabId)
      if (!isEmpty(selectedTab)) {
        setActiveTabId(selectedTabId)
        return
      }
    }
    setActiveTabId(TABS.at(0).id)
  }, [selectedTabId])

  const textInputChange = (e) => {
    const name = e.target?.name
    const value = e.target?.value
    switch (name) {
      case 'username':
        setNewUsername(value)
        break
      case 'twitter':
        setNewTwitterId(value)
        break
      default:
        break
    }
  }

  const setEditMode = () => {
    setActiveTabId(TABS[0].id)
    setState('edit')
  }

  const tabChange = (e) => {
    if (state === 'edit') return
    const tabId = e.target.htmlFor
    if (tabId === 'user-api_tab_four') setState('noEdit')
    else setState('read')
    setActiveTabId(tabId)
  }

  return (
    <OrderUpdateModalCss gridColumns={gridColumns}>
      <div className='popUpContainer user-account variable-width'>
        <header>
          <div className='profile_wrapper'>
            <AvatarForm />
            <div className='profile_name'>
              <ContentSwitcherByState
                noWrapper
                activeState={state}
                stateObject={{
                  default: (
                    <>
                      {username}
                      <span className='email_address'>{email || 'email@address.com'}</span>
                    </>
                  ),
                  edit: (
                    <>
                      <input
                        name='username'
                        type='text'
                        className='edit_username'
                        value={newUsername}
                        onChange={textInputChange}
                        placeholder={username || 'Set Username'}
                      />
                      <span className='email_address'>{email || 'email@address.com'}</span>
                    </>
                  ),
                  public: <></>,
                }}
              />
              {/* <!-- <span className="profile_description">Straight Baller</span> --> */}
            </div>
            <div
              className='user_signout'
              onClick={() => {
                signOut()
                disconnectWallet()
                closeModal()
              }}
            >
              Sign out
            </div>
          </div>
          <div className='closePopUp' onClick={closeModal}>
            X
          </div>
        </header>

        <article>
          <div className='user_tabs_wrapper'>
            {TABS.map((tab) => (
              <input
                key={tab.id}
                className='radio'
                id={tab.id}
                name='wallet_tabs_group_1'
                type='radio'
                defaultChecked={activeTabId === tab.id}
              />
            ))}

            <div className='user_tabs'>
              {TABS.map((tab) => (
                <label
                  key={tab.id}
                  className={`user_tab ${activeTabId === tab.id ? 'active' : ''}`}
                  id={tab.id}
                  htmlFor={tab.id}
                  onClick={tabChange}
                >
                  {tab.caption}
                </label>
              ))}
            </div>
            <div className='user_panels'>
              <ContentSwitcherByState
                noWrapper
                activeState={activeTabId}
                stateObject={TABS.reduce(
                  (stateObj, item) => ({
                    ...stateObj,
                    [item.id]: item.panel,
                  }),
                  {}
                )}
              />
            </div>
          </div>

          <div className='content column action_area'>
            <ContentSwitcherByState
              noWrapper
              activeState={state}
              stateObject={{
                noEdit: <></>,
                read: (
                  <button className='edit_profile' onClick={setEditMode}>
                    Edit username
                  </button>
                ),
                edit: (
                  <>
                    <button className='save_profile' onClick={saveClick}>
                      Save
                    </button>
                    <button className='cancel_profile' onClick={() => setState('read')}>
                      Cancel
                    </button>
                  </>
                ),
                public: <></>,
              }}
            />
          </div>
        </article>
      </div>
    </OrderUpdateModalCss>
  )
}
